import { api } from '@/api';
import router from '@/router';
import { getLocalToken, removeLocalToken, saveLocalToken } from '@/utils';
import { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {
    commitSetCategories, commitSetContacts,
    commitSetStatuses,
} from './mutations';
import { ContactsState } from './state';
import { dispatchCheckApiError } from '../main/actions';
import {IContactsCategoryCreate} from '@/interfaces';

type MainContext = ActionContext<ContactsState, State>;

export const actions = {
    async actionGetStatuses(context: MainContext) {
        try {
            const response = await api.getContactsStatuses(context.rootState.main.token);
            if (response.data) {
                commitSetStatuses(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetCategories(context: MainContext) {
        try {
            const response = await api.getContactsCategories(context.rootState.main.token);
            if (response.data) {
                commitSetCategories(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionCreateCategory(context: MainContext, payload: IContactsCategoryCreate) {
        try {
            const response = await api.createContactsCategory(context.rootState.main.token, payload);
            if (response.data) {
                await dispatchGetCategories(context);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateCategory(context: MainContext, payload: { id: string, category: IContactsCategoryCreate}) {
        try {
            const response = await api.updateContactsCategory(
                context.rootState.main.token, payload.id, payload.category);
            if (response.data) {
                await dispatchGetCategories(context);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionDeleteCategory(context: MainContext, payload: { id: string }) {
        try {
            const response = await api.deleteContactsCategory(context.rootState.main.token, payload.id);
            await dispatchGetCategories(context);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetContacts(context: MainContext, payload: {
        searchText?: string, statusId?: number, categoryId?: number }) {
        try {
            const response = await api.getContacts(
                context.rootState.main.token, payload.searchText, payload.statusId, payload.categoryId);
            if (response.data) {
                commitSetContacts(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionAddContact(context: MainContext, payload: { data: any }) {
        try {
            const response = await api.addContact(payload.data, context.rootState.main.token);
            await dispatchGetContacts(context, {});
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateContact(context: MainContext, payload: { contactId: number, data: any }) {
        try {
            const response = await api.updateContact(payload.contactId, payload.data, context.rootState.main.token);
            await dispatchGetContacts(context, {});
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
};

const { dispatch } = getStoreAccessors<ContactsState | any, State>('');

export const dispatchGetStatuses = dispatch(actions.actionGetStatuses);
export const dispatchGetCategories = dispatch(actions.actionGetCategories);
export const dispatchCreateCategory = dispatch(actions.actionCreateCategory);
export const dispatchUpdateCategory = dispatch(actions.actionUpdateCategory);
export const dispatchDeleteCategory = dispatch(actions.actionDeleteCategory);
export const dispatchGetContacts = dispatch(actions.actionGetContacts);
export const dispatchAddContact = dispatch(actions.actionAddContact);
export const dispatchUpdateContact = dispatch(actions.actionUpdateContact);
